import { css } from 'lit';
export const globalVariables = css `
  :root,
  :host {
    --c-default-border-color: #666;
    --c-default-error-color: #ce4141;
    --c-default-focus-color: #0078d4;
    --c-default-primary-color: #0b3d91;
    --c-default-secondary-color: #fc3d21;
    --c-default-success-color: #4caf50;
    --c-default-warning-color: #ffc107;
    --c-default-text-color: rgba(0, 0, 0, 0.87);
  }
`;
export const globalStyles = css `
  ${globalVariables}

  /* apply a natural box layout model to all elements, but allowing components to change */
  :host {
    box-sizing: border-box;
  }
  *,
  *:before,
  *:after {
    box-sizing: inherit;
  }

  /* screen reader visible */
  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
  }
`;
export const tooltipStyles = css `
  /* -- CSS tooltips -- */
  [tooltip] {
    position: relative;
  }

  [tooltip]:after {
    background: hsla(0, 0%, 20%, 1);
    border-radius: 0.25em;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
    color: #eee;
    content: attr(tooltip);
    display: block;
    font-family: 'Roboto';
    font-size: 1rem;
    font-weight: normal;
    letter-spacing: normal;
    opacity: 0;
    padding: 0.25em 0.5em;
    pointer-events: none;
    position: absolute;
    text-transform: none;
    transition: opacity 0.2s linear, transform 0.2s ease-in-out;
    white-space: pre;
    width: auto;
    z-index: inherit;
  }

  /* support older tooltip-text prop */
  [tooltip-text]:after {
    content: attr(tooltip-text);
  }

  /* default position is bottom */
  [tooltip]:after {
    top: 100%;
    left: 50%;
    transform: translate(-50%, 0);
  }

  [tooltip-position='left']:after {
    top: 50%;
    left: auto;
    right: 100%;
    transform: translate(0, -50%);
  }

  [tooltip-position='right']:after {
    top: 50%;
    left: 100%;
    right: auto;
    transform: translate(0, -50%);
  }

  [tooltip-position='top']:after {
    top: auto;
    left: 50%;
    right: auto;
    bottom: 100%;
    transform: translate(-50%, 0);
  }

  [tooltip-position='bottom right']:after {
    left: auto;
    right: 0;
    transform: translate(0, 0);
  }

  [tooltip-position='bottom left']:after {
    left: 0;
    transform: translate(0, 0);
  }

  [tooltip-position='top right']:after {
    top: auto;
    left: auto;
    right: 0;
    bottom: 100%;
    transform: translate(0, 0);
  }

  [tooltip-position='top left']:after {
    top: auto;
    left: 0;
    bottom: 100%;
    transform: translate(0, 0);
  }

  /* tooltip hover styles */
  [tooltip]:hover {
    z-index: 99;
    overflow: visible;
  }

  [tooltip]:hover:after {
    opacity: 0.9;
    transform: translate(-50%, 0.5em);
  }

  [tooltip-position='left']:hover:after {
    transform: translate(-0.25em, -50%);
  }

  [tooltip-position='right']:hover:after {
    transform: translate(0.25em, -50%);
  }

  [tooltip-position='top']:hover:after {
    transform: translate(-50%, -0.5em);
  }

  [tooltip-position='bottom left']:hover:after,
  [tooltip-position='bottom right']:hover:after {
    transform: translate(0, 0.5em);
  }

  [tooltip-position='top left']:hover:after,
  [tooltip-position='top right']:hover:after {
    transform: translate(0, -0.5em);
  }

  c-button-icon [tooltip]:after {
    font-size: 0.9em;
  }
`;
